export enum KbaFailureReason {
    FAILEDAUTHQUESTIONS = 'failed_iauth_questions',
    INDIVIDUALNOTFOUND = 'individual_not_found',
    GENERATEQUESTIONFAILED = "generate_question_failed",
    TRANSACTIONEXPIRED = 'transaction_expired'
}
